export function buildAnalyticsErrorMessage(errorTag: string, statusMessage: string) {
  return {
    statusMessages: {
      [errorTag]: statusMessage,
    },
  };
}
